import { setSelectedClient } from "../../state/clientMasterSlice"
import {
  faPlus,
  faUser,
  faPenToSquare,
  faGlobe,
} from "@fortawesome/free-solid-svg-icons"
import { apiRoute, linksUrl } from "../../constants/enum"
import { useNavigate } from "react-router-dom"
import { useDispatch } from "react-redux"
import { useGet } from "../../api/reactQueryCustomHooks"
import { ErrorCard, LoadingCard, MainContainer, NextUITable } from "../../components"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { ROW_ACTION_BTN_TYPE } from "../../components/NextUITable"

function ClientMaster() {
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const exportColumns = [
    { uid: "client_code", name: "CLIENT CODE" },
    { uid: "client_name", name: "CLIENT NAME" },
    { uid: "client_group", name: "CLIENT GROUP" },
    { uid: "server_name", name: "SERVER NAME" },
    { uid: "client_db", name: "CLIENT DB" },
    { uid: "client_db_uid", name: "CLIENT DB UID" },
    { uid: "client_db_port", name: "CLIENT DB Port" },
  ]

  const {
    isLoading,
    isError,
    data = [],
  } = useGet({
    url: apiRoute.clientMaster.read,
    queryKey: "ClientMaster",
  })

  const columns = [
    {
      name: "ACTIONS",
      uid: "menuActions",
    },
    { uid: "client_code", name: "CLIENT CODE" },
    { uid: "client_name", name: "CLIENT NAME" },
    { uid: "client_group", name: "CLIENT GROUP" },
    { uid: "server_name", name: "SERVER NAME" },
    { uid: "client_db", name: "CLIENT DB" },
    { uid: "client_db_uid", name: "CLIENT DB UID" },
    { uid: "client_db_port", name: "CLIENT DB PORT" }
  ]

  const INITIAL_VISIBLE_COLUMNS = [
    "menuActions",
    "client_code",
    "client_name",
    "client_group",
    "server_name",
    "client_db",
    "client_db_uid",
    "client_db_port"
  ]

  const topActionBtn = [
    {
      icon: <FontAwesomeIcon icon={faPlus} />,
      onClick: () => {
        navigate(linksUrl.clientMaster.add)
      },
      label: "Add Client", 
    },
  ]

  

  const rowMenuActionBtn = [
    {
      icon: <FontAwesomeIcon icon={faPenToSquare} />,
      onClick: (item) => {
        dispatch(setSelectedClient(item))
        navigate(linksUrl.clientMaster.edit.details)
      },
      label: "Edit Details",
      type: ROW_ACTION_BTN_TYPE.link,
    },
    {
      icon: <FontAwesomeIcon icon={faPenToSquare} />,
      onClick: (item) => {
        dispatch(setSelectedClient(item))
        navigate(linksUrl.clientMaster.edit.password)
      },
      label: "Change Password",
      type: ROW_ACTION_BTN_TYPE.link,
    },
    {
      icon: <FontAwesomeIcon icon={faUser} />,
      onClick: (item) => {
        dispatch(setSelectedClient(item))
        navigate(linksUrl.userMaster.read)
      },
      label: "User",
      type: ROW_ACTION_BTN_TYPE.link,
    },
    {
      icon: <FontAwesomeIcon icon={faGlobe} />,
      onClick: (item) => {
        dispatch(setSelectedClient(item))
        navigate(linksUrl.appClientMapping.read)
      },
      label: "App",
      type: ROW_ACTION_BTN_TYPE.link,
    },
  ]

  if (isLoading) {
    return <LoadingCard />
  }

  if (isError) {
    return <ErrorCard />
  }

  return (
    <div>
      <MainContainer pageName="Client Master">
        <NextUITable
          INITIAL_VISIBLE_COLUMNS={INITIAL_VISIBLE_COLUMNS}
          data={data}
          columns={columns}
          exportColumns={exportColumns}
          topActionBtn={topActionBtn}
          
          rowMenuActionBtn={rowMenuActionBtn}
          downloadFileName="Client_Master"
          id="Client_Code"
        />
      </MainContainer>
    </div>
  )
}

export default ClientMaster
